var Backbone = require('backbone');
var _ = require('underscore');
var Section = require('front/pages/Section/Section');
var SubSectionDummy = require('front/pages/Section/SubSectionDummy');

var SessionWatcher = require('front/components/SessionWatcher/SessionWatcher');

var Archives = require('front/pages/Archives/Archives');

var Awards = require('front/pages/Awards/Awards');
var AwardsADG = require('front/pages/AwardsADG/AwardsADG');
var AwardsADGWinnersPopup = require('front/pages/AwardsADGWinnersPopup/AwardsADGWinnersPopup');
var AwardsADGCeremonyPopup = require('front/pages/AwardsADGCeremonyPopup/AwardsADGCeremonyPopup');
var AwardsADGEligiblePopup = require('front/pages/AwardsADGEligiblePopup/AwardsADGEligiblePopup');
var AwardsAcademyPopup = require('front/pages/AwardsAcademyPopup/AwardsAcademyPopup');
var AwardsEmmyPopup = require('front/pages/AwardsEmmyPopup/AwardsEmmyPopup');
var AwardsHonoredPopup = require('front/pages/AwardsHonoredPopup/AwardsHonoredPopup');

var Benefits = require('front/pages/Benefits/Benefits');
var BenefitsHealthPopup = require('front/pages/BenefitsHealthPopup/BenefitsHealthPopup');
var BenefitsClassesPopup = require('front/pages/BenefitsClassesPopup/BenefitsClassesPopup');
// var BenefitsVideosPopup = require('front/pages/BenefitsVideosPopup/BenefitsVideosPopup');
var BenefitsRepresentedPopup = require('front/pages/BenefitsRepresentedPopup/BenefitsRepresentedPopup');
var BenefitsScholarshipPopup = require('front/pages/BenefitsScholarshipPopup/BenefitsScholarshipPopup');

var Contact = require('front/pages/Contact/Contact');

var Dues = require('front/pages/Dues/Dues');

var Events = require('front/pages/Events/Events');
var EventsPopup = require('front/pages/EventsPopup/EventsPopup');

var Faq = require('front/pages/Faq/Faq');

var Guild = require('front/pages/Guild/Guild');
var GuildPopup = require('front/pages/GuildPopup/GuildPopup');
var GuildIatsePopup = require('front/pages/GuildIatsePopup/GuildIatsePopup');
var GuildProductionDesignInitiative = require('front/pages/GuildProductionDesignInitiative/GuildProductionDesignInitiative');
var GuildProductionDesignInitiativePopup = require('front/pages/GuildProductionDesignInitiativePopup/GuildProductionDesignInitiativePopup');
var GuildBoard = require('front/pages/GuildBoard/GuildBoard');
var GuildStaff = require('front/pages/GuildStaff/GuildStaff');

var Index = require('front/pages/Index/Index');

var Join = require('front/pages/Join/Join');
var JoinPortfolioReview = require('front/pages/JoinPortfolioReview/JoinPortfolioReview');
var JoinPopup = require('front/pages/JoinPopup/JoinPopup');

var LoginPopup = require('front/pages/LoginPopup/LoginPopup');

var Media = require('front/pages/Media/Media');
var MediaPopup = require('front/pages/MediaPopup/MediaPopup');

var Members = require('front/pages/Members/Members');
var MembersPopup = require('front/pages/MembersPopup/MembersPopup');

var MyADG = require('front/pages/MyADG/MyADG');
var MyADGPayPopup = require('front/pages/MyADGPayPopup/MyADGPayPopup');
var MyADGViolationPopup = require('front/pages/MyADGViolationPopup/MyADGViolationPopup');
var MyADGVisitPopup = require('front/pages/MyADGVisitPopup/MyADGVisitPopup');
var MyADGJobPopup = require('front/pages/MyADGJobPopup/MyADGJobPopup');
var MyADGAvailabilityPopup = require('front/pages/MyADGAvailabilityPopup/MyADGAvailabilityPopup');

var NotFound = require('front/pages/NotFound/NotFound');

var Perspective = require('front/pages/Perspective/Perspective');
var PerspectivePopup = require('front/pages/PerspectivePopup/PerspectivePopup');

var Press = require('front/pages/Press/Press');

var Privacy = require('front/pages/Privacy/Privacy');

var Rates = require('front/pages/Rates/Rates');
var RatesListingsPopup = require('front/pages/RatesListingsPopup/RatesListingsPopup');
var RatesBulletinPopup = require('front/pages/RatesBulletinPopup/RatesBulletinPopup');

var Search = require('front/pages/Search/Search');

var Terms = require('front/pages/Terms/Terms');

var ANIMATION_DURATION = 500;


module.exports = Backbone.Router.extend({
    routes: {
        'archives(/)': 'archives',

        'awards(/)': 'awards',
        'awards/adg(/)': 'awardsADG',
        'awards/adg/winners/:year(/)': 'awardsADGWinnersPopup',
        'awards/adg/nominees/:year(/)': 'awardsADGWinnersPopup',
        'awards/adg/ceremony(/)': 'awardsADGCeremonyPopup',
        'awards/adg/eligible-projects/:category/': 'awardsADGEligiblePopup',
        'awards/academy/:year(/)': 'awardsAcademyPopup',
        'awards/emmy/:year(/)': 'awardsEmmyPopup',

        'awards/:category/:person(/)': 'awardsHonoredPopup',

        'benefits(/)': 'benefits',
        'benefits/health-and-pension(/)': 'benefitsHealthPopup',
        'benefits/training-classes(/)': 'benefitsClassesPopup',
        // 'benefits/training-classes/:idclass(/)': 'benefitsClassesPopup',
        // 'benefits/training-videos(/)': 'benefitsVideosPopup',
        'benefits/represented-by-iatse(/)': 'benefitsRepresentedPopup',
        'benefits/scholarship-fund(/)': 'benefitsScholarshipPopup',

        'contact(/)': 'contact',

        'dues(/)': 'dues',

        'events(/)': 'events',
        'events/:slug(/)': 'eventsPopup',

        'faq(/)': 'faq',

        'the-guild(/)': 'guild',
        'the-guild/full-history(/)': 'guildPopup',
        'the-guild/represented-by-iatse(/)': 'guildIatsePopup',
        'the-guild/production-design-initiative(/)': 'guildProductionDesignInitiative',
        'the-guild/production-design-initiative/application(/)': 'guildProductionDesignInitiativePopup',
        'the-guild/board-councils-and-committees(/)': 'guildBoard',
        'the-guild/staff-and-faq(/)': 'guildStaff',

        '': 'index',

        'join(/)': 'join',
        'join/portfolio-review(/)': 'joinPortfolioReview',
        'join/:category(/)': 'joinPopup',

        'login(/)': 'loginPopup',

        'videos(/)': 'media',
        'videos/:slug(/)': 'mediaPopup',

        'directory/': 'members',
        'directory/:slug(/)': 'membersPopup',

        'my-adg(/)': 'myADG',
        'my-adg/pay-dues(/)': 'myADGPayPopup',
        'my-adg/workspace-violation(/)': 'myADGViolationPopup',
        'my-adg/request-a-visit(/)': 'myADGVisitPopup',
        'my-adg/job-report(/)': 'myADGJobPopup',
        'my-adg/availability(/)': 'myADGAvailabilityPopup',

        'perspective(/)': 'perspective',
        'perspective/:slug(/)': 'perspectivePopup',

        'press(/)': 'press',

        'privacy-policy(/)': 'privacy',

        'rates-and-contracts(/)': 'rates',
        'rates-and-contracts/production-listings/:region(/)': 'ratesListingsPopup',
        'rates-and-contracts/production-bulletin(/)': 'ratesBulletinPopup',

        'reset/:token(/)': 'resetPopup',

        'search/': 'search',
        'search/?*queryString': 'search',

        'terms-of-use(/)': 'terms'
    },

    //checks if routes to another view (not one currently active) and reloads the page,
    //it's important for search requests, which can be made from any page, including search page by itself
    route: function (route, name, callback) {
        var router = this;
        if (!callback) callback = this[name];

        var f = function () {
            var currentViewClass = app.state.currentViewClass;
            var forceReload = false;

            //execute route callback
            //try is for some views that can't render itself property in SPA mode (members for example)
            //so next code with reload wasn't executed
            try {
                callback.apply(router, arguments);
            } catch (error) {
                forceReload = true;
            }

            if (forceReload || (currentViewClass && currentViewClass != app.state.currentViewClass)) {
                $('body').hide(); //prevent empty page render as SPA (reload doesn't refresh page immidiately)
                window.location.reload();
            } else {
                this.trackSPAPageView();
            }
        };

        return Backbone.Router.prototype.route.call(this, route, name, f);
    },


    trackSPAPageView: function () {
        var loc = location.pathname + location.search + location.hash;

        this.visitedPages = this.visitedPages || {};

        //do not track first route, ga will track it by itself on initialization
        if (this.notFirstRoute && !this.visitedPages[loc]) {
            //simply set ga('send', 'pageview', [page]) is not recommended
            //because base url doesn't changed and all subsequent events (if any and if they are not pageview)
            //will fire for initial url on wivh page was loaded
            //https://developers.google.com/analytics/devguides/collection/analyticsjs/single-page-applications
            window.ga && ga('set', 'page', loc);
            window.ga && ga('send', 'pageview');
        }

        this.notFirstRoute = true;
        this.visitedPages[loc] = true;
    },


    archives: function () {
        this.activate(Archives, {view: SubSectionDummy, viewData: {}});
    },


    awards: function () {
        this.activate(Awards, {view: SubSectionDummy, viewData: {}});
    },


    awardsADG: function () {
        this.activate(AwardsADG, {view: SubSectionDummy, viewData: {}});
    },


    awardsADGWinnersPopup: function (year) {
        if (!app.state.viewConstructor) {
            this.history.push(Urls['front:awards_adg']()); //back url for direct popup open
        }
        //set underlying page as current active page view, otherwise set default parent page for this popup
        this.activate(app.state.viewConstructor || AwardsADG, {view: AwardsADGWinnersPopup, viewData: {year: year}});
    },


    awardsADGCeremonyPopup: function () {
        if (!app.state.viewConstructor) {
            this.history.push(Urls['front:awards_adg']()); //back url for direct popup open
        }
        //set underlying page as current active page view, otherwise set default parent page for this popup
        this.activate(app.state.viewConstructor || AwardsADG, {view: AwardsADGCeremonyPopup, viewData: {}});
    },


    awardsADGEligiblePopup: function (category) {
        if (!app.state.viewConstructor) {
            this.history.push(Urls['front:awards_adg']()); //back url for direct popup open
        }
        //set underlying page as current active page view, otherwise set default parent page for this popup
        this.activate(app.state.viewConstructor || AwardsADG, {view: AwardsADGEligiblePopup, viewData: {
            category: category,
            parent: 'awards'
        }});
    },


    awardsAcademyPopup: function (year) {
        if (!app.state.viewConstructor) {
            this.history.push(Urls['front:awards']()); //back url for direct popup open
        }
        //set underlying page as current active page view, otherwise set default parent page for this popup
        this.activate(app.state.viewConstructor || Awards, {view: AwardsAcademyPopup, viewData: {year: year}});
    },


    awardsEmmyPopup: function (year) {
        if (!app.state.viewConstructor) {
            this.history.push(Urls['front:awards']()); //back url for direct popup open
        }
        //set underlying page as current active page view, otherwise set default parent page for this popup
        this.activate(app.state.viewConstructor || Awards, {view: AwardsEmmyPopup, viewData: {year: year}});
    },


    awardsHonoredPopup: function (category, person) {
        if (!app.state.viewConstructor) {
            this.history.push(Urls['front:awards']()); //back url for direct popup open
        }
        //set underlying page as current active page view, otherwise set default parent page for this popup
        this.activate(app.state.viewConstructor || Awards, {view: AwardsHonoredPopup, viewData: {category: category, person: person}});
    },


    benefits: function () {
        this.activate(Benefits, {view: SubSectionDummy, viewData: {}});
    },


    benefitsHealthPopup: function () {
        if (!app.state.viewConstructor) {
            this.history.push(Urls['front:benefits']()); //back url for direct popup open
        }
        //set underlying page as current active page view, otherwise set default parent page for this popup
        this.activate(app.state.viewConstructor || Benefits, {view: BenefitsHealthPopup, viewData: {}});
    },


    benefitsClassesPopup: function () {
        if (!app.state.viewConstructor) {
            this.history.push(Urls['front:benefits']()); //back url for direct popup open
        }
        //set underlying page as current active page view, otherwise set default parent page for this popup
        this.activate(app.state.viewConstructor || Benefits, {view: BenefitsClassesPopup, viewData: {}});
    },


    // benefitsVideosPopup: function () {
    //     if (!app.state.viewConstructor) {
    //         this.history.push(Urls['front:benefits']()); //back url for direct popup open
    //     }
    //     //set underlying page as current active page view, otherwise set default parent page for this popup
    //     this.activate(app.state.viewConstructor || Benefits, {view: BenefitsVideosPopup, viewData: {}});
    // },

    benefitsRepresentedPopup: function () {
        if (!app.state.viewConstructor) {
            this.history.push(Urls['front:benefits']()); //back url for direct popup open
        }
        //set underlying page as current active page view, otherwise set default parent page for this popup
        this.activate(app.state.viewConstructor || Benefits, {view: BenefitsRepresentedPopup, viewData: {}});
    },


    benefitsScholarshipPopup: function () {
        if (!app.state.viewConstructor) {
            this.history.push(Urls['front:benefits']()); //back url for direct popup open
        }
        //set underlying page as current active page view, otherwise set default parent page for this popup
        this.activate(app.state.viewConstructor || Benefits, {view: BenefitsScholarshipPopup, viewData: {}});
    },


    contact: function () {
        this.activate(Contact, {view: SubSectionDummy, viewData: {}});
    },


    dues: function () {
        this.activate(Dues, {view: SubSectionDummy, viewData: {}});
    },


    events: function () {
        this.activate(Events, {view: SubSectionDummy, viewData: {}});
    },


    eventsPopup: function (slug) {
        if (!app.state.viewConstructor) {
            this.history.push(Urls['front:events']()); //back url for direct popup open
        }
        //set underlying page as current active page view, otherwise set default parent page for this popup
        this.activate(app.state.viewConstructor || Events, {view: EventsPopup, viewData: {slug: slug}});
    },


    faq: function () {
        this.activate(Faq, {view: SubSectionDummy, viewData: {}});
    },


    guild: function () {
        this.activate(Guild, {view: SubSectionDummy, viewData: {}});
    },


    guildPopup: function () {
        if (!app.state.viewConstructor) {
            this.history.push(Urls['front:guild']()); //back url for direct popup open
        }
        //set underlying page as current active page view, otherwise set default parent page for this popup
        this.activate(app.state.viewConstructor || Guild, {view: GuildPopup, viewData: {}});
    },


    guildIatsePopup: function () {
        if (!app.state.viewConstructor) {
            this.history.push(Urls['front:guild']()); //back url for direct popup open
        }
        //set underlying page as current active page view, otherwise set default parent page for this popup
        this.activate(app.state.viewConstructor || Guild, {view: GuildIatsePopup, viewData: {}});
    },


    guildProductionDesignInitiative: function () {
        this.activate(GuildProductionDesignInitiative, {view: SubSectionDummy, viewData: {}});
    },


    guildProductionDesignInitiativePopup: function () {
        if (!app.state.viewConstructor) {
            this.history.push(Urls['front:guild_production_design_initiative']()); //back url for direct popup open
        }
        //set underlying page as current active page view, otherwise set default parent page for this popup
        this.activate(app.state.viewConstructor || GuildProductionDesignInitiative, {view: GuildProductionDesignInitiativePopup, viewData: {}});
    },


    guildBoard: function () {
        this.activate(GuildBoard, {view: SubSectionDummy, viewData: {}});
    },


    guildStaff: function () {
        this.activate(GuildStaff, {view: SubSectionDummy, viewData: {}});
    },


    index: function () {
        this.activate(Index, {view: SubSectionDummy, viewData: {}});
    },


    join: function () {
        this.activate(Join, {view: SubSectionDummy, viewData: {}});
    },


    joinPortfolioReview: function () {
        this.activate(JoinPortfolioReview, {view: SubSectionDummy, viewData: {}});
    },


    joinPopup: function (category) {
        if (!app.state.viewConstructor) {
            this.history.push(Urls['front:join']()); //back url for direct popup open
        }
        //set underlying page as current active page view, otherwise set default parent page for this popup
        this.activate(app.state.viewConstructor || Join, {view: JoinPopup, viewData: {category: category}});
    },


    loginPopup: function () {
        if (!app.state.viewConstructor) {
            this.history.push(Urls['front:index']()); //back url for direct popup open
        }
        //set underlying page as current active page view, otherwise set default parent page for this popup
        this.activate(app.state.viewConstructor || Index, {view: LoginPopup, viewData: {
            state: 'login'
        }});
    },


    media: function () {
        this.activate(Media, {view: SubSectionDummy, viewData: {}});
    },


    mediaPopup: function (slug) {
        if (!app.state.viewConstructor) {
            this.history.push(Urls['front:media']()); //back url for direct popup open
        }
        //set underlying page as current active page view, otherwise set default parent page for this popup
        this.activate(app.state.viewConstructor || Media, {view: MediaPopup, viewData: {slug: slug}});
    },


    members: function () {
        this.activate(Members, {view: SubSectionDummy, viewData: {}});
    },


    membersPopup: function (slug) {
        if (!app.state.viewConstructor) {
            this.history.push(Urls['front:members']()); //back url for direct popup open
        }
        //set underlying page as current active page view, otherwise set default parent page for this popup
        this.activate(app.state.viewConstructor || Members, {view: MembersPopup, viewData: {slug: slug}});
    },


    myADG: function () {

        //in some cases we need page reload to update its info
        //in case of availability change
        //in case of profile changes
        if (this.needReloadPages && this.needReloadPages['my-adg']) {
            window.location.reload();

            return;
        }

        this.activate(MyADG, {view: SubSectionDummy, viewData: {}});
    },


    myADGPayPopup: function () {
        if (!app.state.viewConstructor) {
            this.history.push(Urls['front:myadg']()); //back url for direct popup open
        }
        //set underlying page as current active page view, otherwise set default parent page for this popup
        this.activate(app.state.viewConstructor || MyADG, {view: MyADGPayPopup, viewData: {}});
    },


    myADGViolationPopup: function () {
        if (!app.state.viewConstructor) {
            this.history.push(Urls['front:myadg']()); //back url for direct popup open
        }
        //set underlying page as current active page view, otherwise set default parent page for this popup
        this.activate(app.state.viewConstructor || MyADG, {view: MyADGViolationPopup, viewData: {}});
    },


    myADGVisitPopup: function () {
        if (!app.state.viewConstructor) {
            this.history.push(Urls['front:myadg']()); //back url for direct popup open
        }
        //set underlying page as current active page view, otherwise set default parent page for this popup
        this.activate(app.state.viewConstructor || MyADG, {view: MyADGVisitPopup, viewData: {}});
    },


    myADGJobPopup: function () {
        if (!app.state.viewConstructor) {
            this.history.push(Urls['front:myadg']()); //back url for direct popup open
        }
        //set underlying page as current active page view, otherwise set default parent page for this popup
        this.activate(app.state.viewConstructor || MyADG, {view: MyADGJobPopup, viewData: {}});
    },


    myADGAvailabilityPopup: function () {
        if (!app.state.viewConstructor) {
            this.history.push(Urls['front:myadg']()); //back url for direct popup open
        }
        //set underlying page as current active page view, otherwise set default parent page for this popup
        this.activate(app.state.viewConstructor || MyADG, {view: MyADGAvailabilityPopup, viewData: {}});
    },


    perspective: function () {
        this.activate(Perspective, {view: SubSectionDummy, viewData: {}});
    },


    perspectivePopup: function (slug) {
        if (!app.state.viewConstructor) {
            this.history.push(Urls['front:perspective']()); //back url for direct popup open
        }
        //set underlying page as current active page view, otherwise set default parent page for this popup
        this.activate(app.state.viewConstructor || Perspective, {view: PerspectivePopup, viewData: {slug: slug}});
    },


    press: function () {
        this.activate(Press, {view: SubSectionDummy, viewData: {}});
    },


    privacy: function () {
        this.activate(Privacy, {view: SubSectionDummy, viewData: {}});
    },


    rates: function () {
        this.activate(Rates, {view: SubSectionDummy, viewData: {}});
    },


    ratesListingsPopup: function (region) {
        if (!app.state.viewConstructor) {
            this.history.push(Urls['front:rates']()); //back url for direct popup open
        }
        //set underlying page as current active page view, otherwise set default parent page for this popup
        this.activate(app.state.viewConstructor || Rates, {view: RatesListingsPopup, viewData: {region: region}});
    },


    ratesBulletinPopup: function () {
        if (!app.state.viewConstructor) {
            this.history.push(Urls['front:rates']()); //back url for direct popup open
        }
        //set underlying page as current active page view, otherwise set default parent page for this popup
        this.activate(app.state.viewConstructor || Rates, {view: RatesBulletinPopup, viewData: {}});
    },


    resetPopup: function (token) {
        if (!app.state.viewConstructor) {
            this.history.push(Urls['front:index']()); //back url for direct popup open
        }
        //set underlying page as current active page view, otherwise set default parent page for this popup
        this.activate(app.state.viewConstructor || Index, {view: LoginPopup, viewData: {
            state: 'reset',
            token: token
        }});
    },


    search: function (queryString) {
        var q = app.utils.queryUrlGetParam('q', queryString) || '';
        var p = (app.utils.queryUrlGetParam('p', queryString) - 0) || 1;
        var c = app.utils.queryUrlGetParam('c', queryString) || 'all';

        this.activate(Search, {view: SubSectionDummy, viewData: {
            query: encodeURIComponent(_.escape(q)),
            page: p,
            category: c.toLowerCase()
        }});
    },


    terms: function () {
        this.activate(Terms, {view: SubSectionDummy, viewData: {}});
    },


    notFound: function () {
        this.activate(NotFound, {view: SubSectionDummy, viewData: {}});
    },


    navigateBack: function () {
        Backbone.history.navigate(this.history[this.history.length - 1], {trigger: 'true'});
        this.history.pop(); //pop, after Backbone.history.navigate onroute listener add return url to history stack, remove it
    },


    activate: function (view, params) {
        params = params || {};

        // view is rendered on server
        if (!app.state.view) {
            params.server = true;
            params.inAnimated = false;
            app.state.viewConstructor = view;
            app.state.view = new view(params);
            app.state.view.activate();
            app.state.currentViewClass = view;

            return;
        }

        app.state.prevView = app.state.view;
        //this.activateStandardLogic(view, params);
        //return;
        if (this.isSectionLogic(app.state.prevView, view, params)) {
            this.activateSectionLogic(params);
        } else {
            this.activateStandardLogic(view, params);
        }

        app.state.currentViewClass = view;
    },

    // navigation activation with full page reload with loader
    activateStandardLogic: function (view, params) {
        var newParams = _.defaults({server: false, inAnimated: true}, params);
        app.state.viewConstructor = view;

        var newView = new view(newParams);
        var duration = params.fastNavigate ? 0 : ANIMATION_DURATION;
        var self = this;

        return Promise.all([app.state.view.playOut({duration: duration, zoom: params.zoomNavigate, view: newView}), newView.loadData()])
            .then(function () {
                app.els.$content.css({minHeight: app.els.$content.height()});

                return app.state.view.deactivate({destroy: true});
            })
            .then(function () {
                app.state.isServer = false;
                app.state.view = newView;
                app.state.view.activate(newParams)
                    .then(function () {
                        app.els.$content.css({minHeight: ''});
                        $(window).scrollTop(0);

                        return app.state.view.playIn({duration: duration, zoom: params.zoomNavigate, view: newView});
                    });
            });
    },

    // navigation activation with popup
    activateSectionLogic: function (subSectionParams) {
        var view = subSectionParams.view;
        var params = _.omit(subSectionParams, 'view');
        params.server = false;
        params.inAnimated = true;
        app.state.view.update(view, params);
        app.state.isServer = false;
    },


    isSectionLogic: function (prevView, view, params) {
        return app.state.prevView instanceof Section && app.state.prevView.constructor === view;
        //return app.state.prevView instanceof Section && view === Section;
    },


    onNeedReloadMessage: function (page) {
        this.needReloadPages = this.needReloadPages || {};

        this.needReloadPages[page] = true;
    },


    start: function () {
        var is404 = app.els.$body.hasClass('Page404');

        $('body').css('opacity', ''); //body is invisible at first state, to prevent scaling artefacts

        app.vent.on('need-reload', this.onNeedReloadMessage.bind(this));

        this.history = [];

        this.listenTo(this, 'route', function (name, args) {
            //do not store popup urls in history, to force popup close to underlying page (even if there is a sequence of opened popups, especially years on awards)
            if (/Popup$/.test(name)) return;

            this.history.push(Backbone.history.fragment);
        }.bind(this));

        //to show popup before 10 minutes to logout and after that show disconnected popup
        new SessionWatcher();

        //If you'd like to use pushState, but have browsers that don't support it natively
        //use full page refreshes instead, you can add {hashChange: false} to the options.
        //for ie 9 mainly
        Backbone.history.start({
            pushState: true,
            hashChange: false,
            silent: is404
        });

        if (is404) {
            this.notFound();
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/Router.js
// module id = 136
// module chunks = 0